import { deleteField } from "firebase/firestore";
import * as matchRepository from "../../repositories/matchRepository";
import * as matchAccessRepository from "../../repositories/matchAccessRepository";
import { patchMatchFields } from "./matchDocumentHelpers";
import { getCurrentAuthUser } from "../../repositories/authRepository";

/**
 * Move legacy credentials off the public match document (creator only).
 */
export async function tryMigrateMatchCredentials(matchId, matchDoc) {
  const uid = getCurrentAuthUser()?.uid;
  if (!uid || !matchDoc || matchDoc.createdBy !== uid) return matchDoc;

  if (!("refCode" in matchDoc) && !("viewCode" in matchDoc)) {
    return matchDoc;
  }

  try {
    await matchAccessRepository.createMatchAccess(matchId, {
      refCode: matchDoc.refCode || "",
      viewCode: matchDoc.viewCode || "",
    });
  } catch (e) {
    const code = e?.code || "";
    if (code !== "permission-denied" && code !== "PERMISSION_DENIED") throw e;
  }

  const patch = {};
  if ("refCode" in matchDoc) patch.refCode = deleteField();
  if ("viewCode" in matchDoc) patch.viewCode = deleteField();
  if (!("hasViewCode" in matchDoc) && matchDoc.viewCode) {
    patch.hasViewCode = Boolean(String(matchDoc.viewCode).trim());
  }
  await patchMatchFields(matchId, patch);
  const fresh = await matchRepository.fetchMatch(matchId);
  return fresh || matchDoc;
}
